import { twoline2satrec } from "satellite.js";

import {
  Datas,
  rsoType,
  subType,
  SatDatasByType,
  Tle,
  SubTypeValue,
  RSOTypeValue,
  SpaceObjectType
} from "../types";
import { convertTo2DArray } from "./common";
import dayjs from "dayjs";
import { MALLIGYOUNG_1 } from "@graphic/constants/sats";

export function getSatDatas(
  tles: Tle[],
  rsoParams: { [key: string]: RSOTypeValue }
): SatDatasByType {
  const datas: SatDatasByType = {
    [rsoType.PAYLOAD]: {
      [subType.STARLINK]: [],
      [subType.ONEWEB]: [],
      [subType.OTHERS]: []
    },
    [rsoType.ROCKET_BODY]: {
      [subType.ROCKET_BODY]: []
    },
    [rsoType.DEBRIS]: {
      [subType.DEBRIS]: []
    },
    [rsoType.UNKNOWN]: {
      [subType.UNKNOWN]: []
    }
  };

  const payloadSubtypes = [subType.STARLINK, subType.ONEWEB, subType.OTHERS];

  tles.forEach(tle => {
    const { name, firstLine, secondLine } = tle;
    const satrec = twoline2satrec(firstLine, secondLine);
    const { satnum } = satrec;

    const noradId = Number(satnum.split(" ").join("").replace(/(^0+)/, ""));
    const type = rsoParams[noradId];

    const object = {
      name,
      satrec,
      type,
      noradId
    };

    if (type === rsoType.PAYLOAD) {
      const subtype =
        payloadSubtypes.find(subtype => name.includes(subtype)) ||
        subType.OTHERS;
      datas[type][subtype]?.push(object);
    } else if (type === rsoType.ROCKET_BODY || type === rsoType.DEBRIS) {
      datas[type][type]?.push(object);
    } else {
      datas[rsoType.UNKNOWN][subType.UNKNOWN]?.push({
        ...object,
        type: rsoType.UNKNOWN
      });
    }
  });

  return datas;
}

export const parseTrajectoryData = (cartesian: number[], startTime: string) => {
  const trajectory2DArray = convertTo2DArray(cartesian, 4);

  let points = [];
  let timeArray = [];

  const startTimeDate = dayjs(startTime);
  trajectory2DArray.forEach(arr => {
    let [positionTime, x, y, z] = arr;
    x = x / 1000;
    y = y / 1000;
    z = z / 1000;

    positionTime = positionTime * 1000 + startTimeDate.valueOf();

    points.push(x, y, z);

    timeArray.push(positionTime);
  });

  return { points, timeArray };
};

export const createSatelliteData = (tles: Tle[]): SpaceObjectType[] => {
  return tles.map((tle: Tle) => {
    const { name, firstLine, secondLine } = tle;
    const satrec = twoline2satrec(firstLine, secondLine);
    const noradId = Number(satrec.satnum.split(" ").join(""));

    let type = "PAYLOAD";
    if (noradId === MALLIGYOUNG_1) {
      type = "ENEMY";
    }
    const data: SpaceObjectType = {
      name,
      satrec,
      type,
      noradId
    };
    return data;
  });
};
